import { EmptyBoxIcon } from '@components/icons/EmptyBoxIcon';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

type EmptyWorkspacesStateProps = {
  disabled?: boolean;
  onCreateClick: () => void;
};

export const EmptyWorkspacesState = ({
  disabled,
  onCreateClick
}: EmptyWorkspacesStateProps) => (
  <div className="flex flex-col items-center justify-center gap-5 py-12 text-center">
    <EmptyBoxIcon className="size-16" />
    <p className="text-muted-foreground text-sm">
      No workspaces yet.
      <br />
      Create one to generate workspace-specific workflows.
    </p>
    <Button
      disabled={disabled}
      onClick={onCreateClick}
      size="sm"
      variant="default"
    >
      <Plus className="mr-2 h-4 w-4" />
      New workspace
    </Button>
  </div>
);
